tetloose.tabs = function () {
    var $tabs = $('.js-tabs');
    if ( $tabs.length ) {
        $tabs.each(function() {
            var $tabsNav = $(this).find('.js-tabsNav'),
                $tabsTrigger = $(this).find('.js-tabsNavTrigger'),
                $tabsItem = $(this).find('.js-tabsItem'),
                $tabsWait = false;
            $tabsItem.eq(0).removeClass('is-active');
            $tabsItem.eq(0).show().addClass('js-active');
            $tabsNav.on('click', '.js-tabsNavTrigger', function(e) {
                e.preventDefault();
                var $t = $(this),
                    $parent = $t.parent(),
                    $activeIndex = $t.index(),
                $parent = $parent.parent();
                if ( $t.hasClass('is-active') || $tabsWait) {
                    return false;
                } else {
                    $tabsWait = true;
                    $parent.find('.js-active').fadeOut('fast', function() {
                        $tabsTrigger.removeClass('is-active');
                        $t.addClass('is-active');
                        $tabsItem.eq($activeIndex).fadeIn('fast',function() {
                            $tabsWait = false;
                        }).addClass('js-active');
                    }).removeClass('js-active');
                }
            });
        });
    }

    var $accordion = $('.js-accordion');
    if ( $accordion.length ) {

        $accordion.each(function() {
            var $accordionItem = $(this).find('.js-accordionItem'),
                $accordionWait = false;

            $accordionItem.on('click', '.js-accordionTrigger', function(e) {
                e.preventDefault();

                var $t = $(this),
                    $parent = $t.parent(),
                    $content = $parent.find('.js-accordionContent');

                if ( !$accordionWait ) {
                    $accordionWait = true;
                    if ( $t.hasClass('is-active') ) {
                        $t.removeClass('is-active');
                        $content.slideUp('fast', function() {
                            $accordionWait = false;
                        });
                    } else {
                        $t.addClass('is-active');
                        $content.slideDown('fast', function() {
                            $accordionWait = false;
                        });
                    }
                }
            });
        });
    }
};
